import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import useDepartmentHeadcount from './useDepartmentHeadcount';
import ChartGlassPanel from '../../components/ChartGlassPanel';

export default function DepartmentHeadcountChart() {
  const data = useDepartmentHeadcount();
  return (
    <ChartGlassPanel>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="department" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Bar dataKey="count" fill="#2563eb" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </ChartGlassPanel>
  );
}
